// @ts-nocheck
import { post } from "@insite/client-framework/Services/ApiService";

export interface SendRestrictedItemFeedbackEmailParams {
    sku: string;
    comment: string;
    reportedUrl: string;
}
const sendRestrictedItemFeedbackEmailUrl = "/api/v1/contactsupervisor/contactsupervisor";

export const sendRestrictedItemFeedbackEmail = async (params: SendRestrictedItemFeedbackEmailParams) => {
    const data = await post(sendRestrictedItemFeedbackEmailUrl, params);
    return data;
};
